import styled from 'styled-components/macro';

import { colors } from '../../../styles/vars';

const QuoteText = styled.div`
  display: block;
  width: 100%;
  color: ${colors['black-six']};

  .placeholder,
  .public-DraftEditor-content {
    font-size: 24px;
    line-height: 1.25;
  }
`;

export default QuoteText;
